import { createActionGroup, props } from '@ngrx/store';

export const AppActions = createActionGroup({
  source: 'App',
  events: {
    'Set Api Release Version': props<{
      apiReleaseVersion: string;
    }>(),
  },
});
